import React, { useState, useRef, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import { Map, GoogleApiWrapper } from "google-maps-react";
import PropTypes from "prop-types";
import { setDefaults, geocode, RequestType } from "react-geocode";

// components
import AddressInput from "@Components/AddressInput";

// Styles
import styles from "./styles.module.css";

const StaticMap = (props) => {
	const { initialCenter, zoom = 14, mapType = "roadmap", google, setGeocodeData = () => {}, height = 100 } = props;
	const [center, setCenter] = useState({ lat: 18.461174, lng: -69.941578 });
	const [address, setAddress] = useState("");
	const mapRef = useRef(null);

	setDefaults({
		key: "AIzaSyB9eh4EYxyjQhXXOXMQBFOC4e5Ryvmlwn8",
		language: "es",
		region: "do",
	});

	useEffect(() => {
		if (mapRef.current && google) {
			google.maps.event.trigger(mapRef.current, "resize");
		}
	}, [height]);

	const onReady = (_, map) => {
		map.setOptions({
			mapTypeId: mapType,
			center: initialCenter,
			fullscreenControl: false,
			streetViewControl: false,
			mapTypeControl: false,
		});
		mapRef.current = map;
	};

	const onDragend = (_, map) => {
		const newCenter = {
			lat: map.center.lat(),
			lng: map.center.lng(),
		};

		geocode(RequestType.LATLNG, `${String(newCenter.lat)},${String(newCenter.lng)}`)
			.then(({ results }) => {
				const addressG = results[0];
				setGeocodeData(addressG);
				setAddress(addressG.formatted_address);
			})
			.catch();
		setCenter(newCenter);
	};

	const getGeometry = (latitudeData, longitudeData) => {
		const map = mapRef.current;
		const newCenter = {
			lat: latitudeData,
			lng: longitudeData,
		};
		setCenter(newCenter);
		geocode(RequestType.LATLNG, `${String(newCenter.lat)},${String(newCenter.lng)}`)
			.then(({ results }) => {
				const addressG = results[0];
				setGeocodeData(addressG);
				setAddress(addressG.formatted_address);
			})
			.catch();
		map.setOptions({
			mapTypeId: mapType,
			center: newCenter,
		});
		mapRef.current = map;
	};

	const centerMapToUserLocation = () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((position) => {
				const userLocation = {
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				};
				setCenter(userLocation);
				getGeometry(position.coords.latitude, position.coords.longitude);
			});
		}
	};

	return (
		<div ref={mapRef}>
			<Map
				google={google}
				style={{
					height: `100%`,
					margin: "0px",
					padding: "0px",
				}}
				containerStyle={{
					position: "relative",
					display: "block",
					minHeight: "500px",
					height: `${height}px`,
					width: "99%",
					margin: "0px",
					padding: "0px",
				}}
				initialCenter={center}
				zoom={zoom}
				onReady={onReady}
				onDragend={onDragend}>
				<div className={styles.searchContainer}>
					<AddressInput
						value={address}
						icon="map"
						fluid
						getgeometry={getGeometry}
						onChange={(e) => {
							const { value } = e.target;
							setAddress(value);
						}}
						className={styles.input}
					/>
				</div>
				<div aria-label="center Map" tabIndex={0} role="button" className={styles.centerButtonContainer} onClick={centerMapToUserLocation}>
					<Icon name="crosshairs" size="large" className={styles.centerIcon} />
				</div>
				<div className={styles.iconContainer}>
					<Icon name="map marker alternate" className={styles.icon} />
				</div>
			</Map>
		</div>
	);
};

StaticMap.propTypes = {
	initialCenter: PropTypes.object,
	setGeocodeData: PropTypes.func,
	zoom: PropTypes.number,
	mapType: PropTypes.oneOf(["satellite", "roadmap"]),
	google: PropTypes.object,
	height: PropTypes.number,
};

export default GoogleApiWrapper({ apiKey: "AIzaSyB9eh4EYxyjQhXXOXMQBFOC4e5Ryvmlwn8" })(StaticMap);
